module.exports = __webpack_public_path__ + "img/no-data.7da6dff8.png";